/** Google Pub/Sub (GBP notifications) webhook shapes (docs/53 §6.3). See ./index.ts for the verification rule and the VERIFY note. */
import { z } from 'zod';

/** Pub/Sub push envelope. The OIDC bearer token is verified first (audience = GOOGLE_PUBSUB_AUDIENCE). */
export const PubSubPush = z.object({
  message: z.looseObject({
    data: z.string().regex(/^[A-Za-z0-9+/=_-]*$/).max(100_000),
    messageId: z.string().max(64),
    publishTime: z.string().max(40),
    attributes: z.record(z.string(), z.string()).optional(),
  }),
  subscription: z.string().max(255),
});

/** Decoded `message.data` for Business Profile notifications (VERIFY: field names on the notification setup page). */
export const GbpNotification = z.looseObject({
  type: z.enum([
    'NEW_REVIEW',
    'UPDATED_REVIEW',
    'GOOGLE_UPDATE',
    'NEW_CUSTOMER_MEDIA',
    'NEW_QUESTION',
    'UPDATED_QUESTION',
    'NEW_ANSWER',
    'UPDATED_ANSWER',
    'DUPLICATE_LOCATION',
    'LOSS_OF_VOICE_OF_MERCHANT',
    'VOICE_OF_MERCHANT_UPDATED',
  ]),
  location: z.string().regex(/^(accounts\/\d+\/)?locations\/\d+$/),
  review: z.string().max(255).optional(),
});
